import { spLog } from "@eventr/common";
import { ColoursObj, ImageRenderer, MainButton, Typography } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import i18n from "i18n/i18next";
import { useEffect, useRef } from "react";
import { routes } from "routing";
import { useGlobalRouter } from "../globalRouter/useGlobalRouter";
import { useThemeContext } from "../../state/themeState/themeContext";
import { logEvent } from "../firebase/firebase";

export const ErrorPage = () => {
  const { pushPath } = useGlobalRouter();
  const themeImages = useThemeContext((s) => s.themeImages);

  // A `useRef`, not `useState`: the counter is written and read back synchronously in the
  // same handler, and it is never read during render. `useState` would compare a stale
  // value against 10 and the easter egg would never fire.
  const taps = useRef(0);
  function _refreshApp() {
    spLog("Window Reload.");

    pushPath(routes.home.path);
    window.location.reload();
  }
  const onHiddenClick = () => {
    taps.current = taps.current + 1;
    if (taps.current === 10) {
      taps.current = 0;
      pushPath(routes.dev.menu.path);
    }
  };

  useEffect(() => {
    logEvent("error_page", {});
  }, []);

  return (
    <Stack
      style={{
        height: "100vh",
        background: ColoursObj.backgrounds.primary,
      }}
      className="center"
      sx={{
        justifyContent: "center",
        alignItems: "center",
        padding: "16px",
        gap: "24px"
      }}>
      <Typography variant="mobileH3" color={ColoursObj.core.primary}>
        {i18n.t("general.unexpected-error")}
      </Typography>
      <ImageRenderer variant="error" src={themeImages?.error} />
      <MainButton
        variant="destructiveBorderless"
        size="large"
        text="Click to reload"
        onClick={_refreshApp}
        style={{
          background: ColoursObj.backgrounds.secondary,
          width: "100%",
        }}
      />
      {/* <MainButton
                variant="dialogue"
                onClick={() => {
                    fullLogout('/authentication/signin')
                }}
                style={{
                    width: '100%',
                }}
            >
                {i18n.t('account.logout')}
            </MainButton> */}
      <div style={{ height: "40px", width: "40px" }} onClick={onHiddenClick} />
    </Stack>
  );
};
